import { get, del, post, put } from '@api/request';

export async function fetchCodeFile(
  { appraisalService, assessmentService },
  authenticationToken,
  { year, type, name },
) {
  let url = `${appraisalService}/appraisal/codes?type=${type}&name=${name}`;
  url += year ? `&year=${year}` : '';
  if(name === 'School Code' || name === 'City Code') {
    url = `${assessmentService}/assessment/taxingunitssummary`;
  }
  const { body } = await get(authenticationToken, url);
  if(name === 'School Code' && body && body.results) {
    body.results = body.results.filter(r => r.taxingUnitType === 'School').map(r => {
      return {
        codeName: r.taxingUnitCode,
        codeDescription: r.taxingUnitName,
      };
    })
  }
  if(name === 'City Code' && body && body.results) {
    body.results = body.results.filter(r => r.taxingUnitType === 'City').map(r => {
      return {
        codeName: r.taxingUnitCode,
        codeDescription: r.taxingUnitName,
      };
    })
  }
  return body;
}

export const deleteCiRecord = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/ci/${payload}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const getSymbologySubsetData = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/symbology/categorizepidlist/marketValue`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const getSymbologySubsetLandData = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/symbology/categorizepidlist/landValue`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const getFeatureFromCoordinates = async (
  { gamaService },
  authenticationToken,
  { type = 'parcels', lat, lng },
) => {
  const url = `${gamaService}/gama/layeratpoint/${lng}/${lat}/${type}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const editCiRecord = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/ci/${payload}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchSearchConfig = async () => {
  const body = {
    results: [
      {
        description: 'ID',
        group: 1,
        grouping: 'Basic Search',
        id: 'ciID',
        operators: ['like'],
        order: 1,
        type: 'string',
      },
      {
        description: 'Name',
        group: 1,
        grouping: 'Basic Search',
        id: 'ciName',
        operators: ['like'],
        order: 2,
        type: 'string',
      },
      {
        description: 'Description',
        group: 1,
        grouping: 'Basic Search',
        id: 'ciDescription',
        operators: ['like'],
        order: 3,
        type: 'string',
      },
      {
        description: 'Address',
        group: 1,
        grouping: 'Basic Search',
        id: 'ciAddress',
        operators: ['like'],
        order: 4,
        type: 'string',
      },
      {
        description: 'Tags',
        group: 1,
        grouping: 'Basic Search',
        id: 'ciTags',
        operators: ['like'],
        order: 5,
        type: 'tags',
      },
      {
        description: 'Date Created',
        group: 1,
        grouping: 'Basic Search',
        id: 'createDt',
        operators: ['=', '>', '>=', '<', '<='],
        order: 6,
        type: 'date',
      },
      {
        description: 'Created By',
        group: 1,
        grouping: 'Basic Search',
        id: 'createdBy',
        operators: ['=', '>', '>=', '<', '<='],
        order: 7,
        type: 'string',
      },
      {
        description: 'Date Updated',
        group: 1,
        grouping: 'Basic Search',
        id: 'updateDt',
        operators: ['=', '>', '>=', '<', '<='],
        order: 8,
        type: 'date',
      },
      {
        description: 'Updated By',
        group: 1,
        grouping: 'Basic Search',
        id: 'updatedBy',
        operators: ['=', '>', '>=', '<', '<='],
        order: 9,
        type: 'string',
      },
    ],
  };
  return body;
};

export const fetchSearchResultsConfig = async (
  { sketchService },
  authenticationToken,
) => {
  const url = `${sketchService}/sketchservice/config/sketchsearchresults`;
  const { body } = await get(authenticationToken, url);
  // console.log('results config');
  // console.log(body);
  // body = {
  //   results: [
  //     {
  //       displayName: 'Sketch ID',
  //       id: 'sketchID',
  //       needFormatting: false,
  //       type: 'numeric'
  //     },
  //     {
  //       displayName: 'Sketch Description',
  //       id: 'description',
  //       needFormatting: false,
  //       type: 'string'
  //     },
  //     {
  //       displayName: 'Date / Time',
  //       id: 'updateDt',
  //       needFormatting: false,
  //       type: 'date'
  //     },
  //     {
  //       displayName: 'User',
  //       id: 'createdBy',
  //       needFormatting: false,
  //       type: 'string'
  //     }
  //   ]
  // };
  return body;
};

export const createCiRecord = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/ci`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const saveSketch = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketches`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

// export const search = async ({ gamaService}, authenticationToken) => {
//   const url = `${ gamaService}/sketchservice/sketches`;
//   const { body } = await get(authenticationToken, url);
//   return body;
// };

export const search = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  if (payload.tags) {
    payload.tags.operator = null;
    payload.tags.values = [payload.tags.value];
  }
  const url = `${gamaService}/gama/ci/search`;
  const { body } = await post(authenticationToken, url, payload);
  // const { body } = await get(authenticationToken, `${ gamaService}/sketchservice/sketches`);
  // console.log(body);
  return body;
};

export const updateCiRecord = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/ci/${payload.ciID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const postComment = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/ci/${payload.ciID}/comments`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const getComments = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/ci/${payload}/comments`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deleteComment = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/ci/${payload}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const postTag = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/${payload.sketchID}/tags`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const getTags = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/${payload}/tags`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const getTaxingUnits = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/property/taxingunitlookup?address=${payload}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const deleteTag = async (
  { sketchService },
  authenticationToken,
  { payload },
) => {
  const url = `${sketchService}/sketchservice/sketch/tag/${payload}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export const getAppraisalCiInitialData = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/property/search`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const getAppraisalSearchData = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  // let data1 = await getPropertyData({ appraisalService }, authenticationToken, {
  //   payload,
  // });
  // return data1;
  const url = `${appraisalService}/appraisal/property/search?page=1&pageSize=5000`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const getCiApiSettings = async (
  { gamaService },
  authenticationToken,
) => {
  const url = `${gamaService}/gama/cisettings`;
  const { body } = await get(authenticationToken, url);
  if (!body) {
    const setData = await setCiApiSettings(
      { gamaService },
      authenticationToken,
      {
        payload: {
          settings: {
            layoutData: {
              layout: 1,
              maps: [
                { type: 'gismap' },
                { type: 'googlemap' },
                { type: 'googlemap' },
              ],
            },
            ciImageryData: [
              { value: 'gismap', label: 'GIS', visible: true },
              { value: 'pictometry', label: 'Pictometry', visible: true },
              { value: 'googlemap', label: 'Google Map', visible: true },
              {
                value: 'googlemapaerial',
                label: 'Google Aerial',
                visible: true,
              },
              {
                value: 'googlemapstreetview',
                label: 'Google Street View',
                visible: true,
              },
              {
                value: 'googlemappictometry',
                label: 'Google Tilt',
                visible: true,
              },
              { value: 'bingmap', label: 'Bing Map', visible: true },
              { value: 'bingmapaerial', label: 'Bing Aerial', visible: true },
              {
                value: 'bingmapstreetview',
                label: 'Bing Street View',
                visible: true,
              },
              {
                value: 'bingmappictometry',
                label: 'Bing Birds Eye',
                visible: true,
              },
            ],
          },
          lastUpdate: null,
        },
      },
    );
    return setData;
  }
  return body;
};

export const setCiApiSettings = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/cisettings`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const getGisApiSettings = async (
  { gamaService },
  authenticationToken,
) => {
  const url = `${gamaService}/gama/gissettings`;
  const { body } = await get(authenticationToken, url);
  if (!body || !body.results || body.results.length === 0) {
    const setData = await setGisApiSettings(
      { gamaService },
      authenticationToken,
      {
        payload: {
          settings: {
            authData: {
              type: 'mapServer',
              authToken: '',
              fileLocation: '',
              mapServerUrl: '',
            },
            layerData: [
              {
                showFill: true,
                display: true,
                fill: '#ecfb79',
                color: '#01171e',
                width: 1,
                fillOpacity: 0.43,
                parcel: true,
                opacity: 1,
                displayInfo: null,
                settingsLabel: 'Parcels',
                value: '1',
                visible: true,
                visibility: '0.25',
                apiType: 'parcels',
                label: null,
                layerNum: [0],
                showStroke: true,
                selectable: true,
                format: 'EPSG:2276',
                zIndex: 8,
                fields: [{ name: 'pid' }],
                serviceUrl: '/gama/tiles/{z}/{x}/{y}?maxArea=100',
                type: 'postgis',
              },
              {
                showFill: true,
                display: true,
                fill: '#ecfb79',
                color: '#01171e',
                width: 1,
                fillOpacity: 0.43,
                parcel: true,
                opacity: 1,
                combinedLayer: true,
                displayInfo: null,
                settingsLabel: 'Parcels2',
                value: '1',
                visible: true,
                visibility: '20',
                apiType: 'parcels',
                label: null,
                layerNum: [0],
                showStroke: true,
                selectable: true,
                format: 'EPSG:2276',
                zIndex: 8,
                fields: [{ name: 'pid' }],
                serviceUrl: '/gama/tiles/{z}/{x}/{y}?minArea=100',
                type: 'postgis',
              },
            ],
            themeData: [
              {
                settingsLabel: 'OpenStreetMap',
                value: 'default',
                visible: true,
                attributions:
                  '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                format: 'EPSG:2276',
                icon: 'openstreetmap',
                serviceUrl:
                  'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                type: 'xyz',
                selected: true,
              },
              {
                icon: 'bing',
                type: 'native',
                value: 'bingmap',
                format: 'EPSG:2276',
                visible: true,
                selected: false,
                serviceUrl: null,
                settingsLabel: 'Bing Map',
              },
              {
                icon: 'bingaerial',
                type: 'native',
                value: 'bingmapaerial',
                format: 'EPSG:2276',
                visible: true,
                selected: false,
                serviceUrl: null,
                settingsLabel: 'Bing Map Aerial',
              },
              {
                type: 'arcgis',
                value: 'floodplain',
                format: 'EPSG:2276',
                visible: true,
                selected: false,
                serviceUrl:
                  'https://hazards.fema.gov/arcgis/rest/services/public/NFHL/MapServer/',
                settingsLabel: 'Floodplain Map',
              },
              {
                settingsLabel: 'ArcGIS Topographic Map',
                value: 'terrain',
                visible: true,
                attributions:
                  'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
                format: 'EPSG:2276',
                icon: 'openstreetmap',
                serviceUrl:
                  'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
                type: 'xyz',
                selected: false,
              },
            ],
            attributeData: [],
          },
          lastUpdate: null,
        },
      },
    );
    return setData;
  }
  return body;
};

export const setGisApiSettings = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/gissettings`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const getPropertySearchData = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  let data1 = await getPropertyData({ appraisalService }, authenticationToken, {
    payload,
  });
  let data2 = await getCurrentYear({ appraisalService }, authenticationToken);
  data1.results.currentYear = data2.results.year;
  return data1;
};

const getCurrentYear = async ({ appraisalService }, authenticationToken) => {
  const url = `${appraisalService}/appraisal/currentyear`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const getPropertyData = async (
  { appraisalService },
  authenticationToken,
  { payload },
) => {
  const url = `${appraisalService}/appraisal/${payload.pid.value}/gis`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const executeSmartlistQuery = async (
  { appraisalService },
  authenticationToken,
  {
    smartListId,
    parameterList,
    previewQuery = 1,
    queryOnly = 0,
    pIDQuery = 0,
    columnsOnly = 0,
  },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/executequery`;
  const { body } = await post(authenticationToken, url, {
    parameterList,
    previewQuery,
    queryOnly,
    pIDQuery,
    columnsOnly,
  });
  return body;
};

export const executeSmartlistQueryCi = async (
  { appraisalService },
  authenticationToken,
  {
    smartListId,
    parameterList,
    pidList = [],
    previewQuery = 1,
    queryOnly = 0,
    pIDQuery = 0,
    columnsOnly = 0,
  },
) => {
  const url = `${appraisalService}/appraisal/smartlist/${smartListId}/executequeryforci`;
  const { body } = await post(authenticationToken, url, {
    parameterList,
    previewQuery,
    queryOnly,
    pIDQuery,
    columnsOnly,
    pidList,
  });
  return body;
};

export const getCountyAbstractData = async (
  { gamaService },
  authenticationToken,
) => {
  const url = `${gamaService}/gama/search/options/abstracts`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const searchByAbstract = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/search/abstracts`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const searchByAbstractNumber = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/search/abstractnumber`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const searchByAbstractName = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/search/abstractname`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const searchBySubdivisionName = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/search/subdivision`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const searchByMarketAreaName = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/search/marketarea`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const getParcelLabelData = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/appraisalfields`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const getPostGisParcelData = async (
  { gamaService },
  authenticationToken,
  { payload },
) => {
  const url = `${gamaService}/gama/parcelshapes`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const getParcelsWithinBounds = async (
  { gamaService },
  authenticationToken,
  { points },
) => {
  const url = `${gamaService}/gama/parcelswithinbounds?points=${points}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const getParcelsInfoWithinBounds = async (
  { gamaService },
  authenticationToken,
  { points },
) => {
  const url = `${gamaService}/gama/parcelinfo/${points}`;
  const { body } = await get(authenticationToken, url);
  return body;
};
